<!-- 
Standard layout for displaying search options.

Offers slots:
- quick-search: for the quick search text field
- search-button: for the search button
- saved-searches-button: for the saved searches menu button
- middle: for other buttons to be displayed to the right of the search buttons
- right: for other buttons to be displayed on the right hand side of the screen
-->
<template>
  <v-container fluid class="pa-0">
    <v-layout wrap>
      <v-flex 
        xs12 sm4 md3 xl2 
        style="min-width:300px"
      >
        <slot name="quick-search"/>
      </v-flex>
      <v-flex shrink>
        <slot name="search-button"/>
      </v-flex>
      <v-flex shrink>
        <slot name="saved-searches-button"/>
      </v-flex>
      <v-flex :xs12="xs" shrink>
        <slot name="middle"/>
      </v-flex>
      <v-spacer/>
      <v-flex :xs12="xs" class="text-sm-right">
        <slot name="right"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    }
  }
};
</script>
